import { DevTool } from "@hookform/devtools";
import React from "react";
import { FieldValues } from "react-hook-form";

const FormDevTool = <T extends FieldValues>(
    props: React.ComponentProps<typeof DevTool<T>>
) => {
    if (import.meta.env.MODE === "development") {
        return <DevTool {...props} />;
    }

    return null;
};

export default FormDevTool;
